import { FC } from 'react'

import { SegmentedControl } from 'cng-common/components/segmentedControl'
import { Translation } from 'cng-common/features/translations'
import { Flex } from 'core-components/library/flex'

import { IPartnersCoverageGroup } from '../../../../model'
import { COVERAGE_TRANSLATION_KEYS } from '../../../translations'

import styles from './MarketSelector.module.scss'

interface IMarketSelectorProps {
  selectedIndex: number
  setSelectedIndex: (index: number) => void
  markets: IPartnersCoverageGroup[]
  isLoading: boolean
}

export const MarketSelector: FC<IMarketSelectorProps> = ({
  selectedIndex,
  setSelectedIndex,
  markets,
  isLoading,
}) => {
  if (!markets.length) {
    return null
  }

  return (
    <Flex flexDirection="column" gap="none">
      <div className={styles.title}>
        <Translation span text={COVERAGE_TRANSLATION_KEYS.marketFilterTitle} />
      </div>
      <SegmentedControl
        selectedItem={selectedIndex}
        backgroudn="bg-white"
        noWrap
        onItemSelect={setSelectedIndex}
      >
        {markets.map((market) => (
          <SegmentedControl.Item key={market.market} isDisabled={isLoading}>
            {/* market labels come from the API, they are not translation keys */}
            <span>{market.marketLabel}</span>
          </SegmentedControl.Item>
        ))}
      </SegmentedControl>
    </Flex>
  )
}
